<div
  [ngClass]="{
    wrapper: true,
    'wrapper--mini': kind === 'mini',
    'wrapper--nano': kind === 'nano'
  }"
>
  <ng-content></ng-content>
</div>
